import {
  fetchGeocodeCached,
  IGeocodeCachedRequest,
  TGeocodeCachedResponse,
} from 'shared/repositories/geo/v1/geocode-cached';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IGeocodeCachedResult } from 'shared/types/geoSuggest';

export const getGeocodeCached = async (
  { httpApi }: IApplicationContext,
  parameters: IGeocodeCachedRequest,
): Promise<IGeocodeCachedResult[] | undefined> => {
  const { response }: TGeocodeCachedResponse = await fetchGeocodeCached({
    httpApi,
    parameters,
  });

  return response.items as IGeocodeCachedResult[];
};
